import { render, staticRenderFns } from "./UserSvg.vue?vue&type=template&id=09c14670"
import script from "./UserSvg.vue?vue&type=script&lang=js"
export * from "./UserSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports